@let cta = ctaConfig();
<pm-dialog
  dialogTitle="ANALYSIS.CREATE_CONFIGURATION.TITLE"
  [size]="'md'"
  [optionalCtaConfig]="cta.optional"
  [primaryCtaButtonConfig]="cta.primary"
  [secondaryCtaButtonConfig]="cta.secondary"
>
  <section class="relative">
    @let stepId = this.stepId();

    @switch (stepId) {
      @case ('general') {
        <pm-general-step-analysis-configuration
          (dataChange)="this.dto.general = $event"
          (validChange)="this.stepIsValid.set($event)"
          [initData]="dto.general"
        />
      }
      @case ('hierarchy') {
        <pm-hierarchy-step-analysis-configuration
          (dataChange)="this.dto.hierarchy = $event"
          (validChange)="this.stepIsValid.set($event)"
          [initData]="dto.hierarchy"
        />
      }
      @case ('errorMeasures') {
        <pm-error-measures-step-analysis-configuration
          (dataChange)="this.dto.errorMeasures = $event"
          (validChange)="this.stepIsValid.set($event)"
          [initData]="dto.errorMeasures"
        />
      }
    }
  </section>
</pm-dialog>
